import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import SwaranandhraService from "../Services/SwaranandhraService";
const LogOut = () => {
    let navigate = useNavigate();
        useEffect(() => { 
            let params={
                token:localStorage.getItem("token")
            }
            SwaranandhraService.userLogout(params).then(()=>{
            localStorage.removeItem("token");
            localStorage.removeItem("serviceList");

            localStorage.clear();
            Swal.fire({
                text: 'You have Successfully Logged Out',
                icon: 'success',
                confirmButtonText: 'Ok',
                confirmButtonClass: "swal-button--confirm"
            }).then(
                function () {
                    navigate("/SwarnandhraLogin")
                }
            );
        })
    }, [])

  
    return (<>
    </>);
}
export default LogOut;